<template>
    <v-chip
        v-if="isProject"
        class="table-label"
        small
        label
        dark
        :color="projectStatusColor"
    >
        <div>{{ $t(projectText) }}</div>
    </v-chip>
    <v-chip
        v-else
        class="table-label"
        small
        label
        dark
        :color="status.color"
    >
        <div>{{ $t(status.text) }}</div>
    </v-chip>
</template>

<script>
export default {
    props: {
        isProject: {
            type: Boolean,
            default: true
        },
        type: {
            type: Number,
            default: -1
        },
        changed: {
            type: Boolean,
            default: false
        },
        terminationDate: {
            type: String,
            default: null
        }
    },
    computed: {
        projectText() {
            switch (this.type) {
                case 0:
                    return "Решение";
                case 1:
                    return "Постановление";
                case 2:
                    return "Распоряжение";
                default:
                    return "NaN";
            }
        },
        projectStatusColor() {
            switch (this.type) {
                case 0:
                    return "#BE95C6";
                case 1:
                    return "#BE95C6";
                case 2:
                    return "#BE95C6";
                default:
                    return "#9D81BA";
            }
        },
        status() {
            let r = { text: "Действующий", color: "#66BB6A" };

            if (this.changed)
                r = { text: "С_изменениями", color: "#FFA726" };

            let date = this.$moment(this.terminationDate);

            if (this.$moment() > date)
                r = { text: "Утративший_силу", color: "#EF5350" };

            return r;
        }
    }
}
</script>